class LogoutService {
  static logout() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('companies');
    localStorage.removeItem('modules');
    localStorage.removeItem('roles');
    window.location.replace('/');
  }
}
export default LogoutService;
